module.exports = __webpack_public_path__ + "static/img/15.1aaf9c36.jpg";